import { reducedStream, reducer } from '@ardoq/rxbeach';
import {
  ViewpointBuilderNavigationState,
  ViewpointBuilderNavigationViewModel,
} from './types';
import { viewpointBuilderNavigationOperations } from './viewpointBuilderNavigationOperations';
import {
  selectViewpointBuilderContext,
  selectTab,
  setSelectedComponentTypeAndCount,
  setGraphCountsAndComponentTypeRepresentation,
  setFormattingRulesCount,
  setGroupingRulesCount,
  setSavedViewpointDetails,
  setCollapsedPathsCount,
  resetViewpointBuilderNavigation,
  setRequiredComponentsCount,
} from './actions';
import { combineLatest, map, Observable, shareReplay } from 'rxjs';
import { i18nLocale$ } from 'streams/i18nLocale$';

export const createViewpointBuilderNavigation$ = (
  namespace: string
): Observable<ViewpointBuilderNavigationViewModel> =>
  combineLatest([
    reducedStream<ViewpointBuilderNavigationState>(
      `viewpointBuilderNavigation$:${namespace}`,
      viewpointBuilderNavigationOperations.getInitialState(),
      [
        reducer(selectTab, viewpointBuilderNavigationOperations.selectTab),
        reducer(
          selectViewpointBuilderContext,
          viewpointBuilderNavigationOperations.selectNavigationModeAndContext
        ),
        reducer(
          setSelectedComponentTypeAndCount,
          viewpointBuilderNavigationOperations.setComponentTypeAndCount
        ),
        reducer(
          setGraphCountsAndComponentTypeRepresentation,
          viewpointBuilderNavigationOperations.setGraphCountsAndComponentTypeRepresentation
        ),
        reducer(
          setFormattingRulesCount,
          viewpointBuilderNavigationOperations.setFormattingRulesCount
        ),
        reducer(
          setGroupingRulesCount,
          viewpointBuilderNavigationOperations.setGroupingRulesCount // TODO AM use property setter from Sindre
        ),
        reducer(
          setCollapsedPathsCount,
          viewpointBuilderNavigationOperations.setCollapsedPathsCount
        ),
        reducer(
          setRequiredComponentsCount,
          viewpointBuilderNavigationOperations.setRequiredComponentsCount
        ),
        reducer(
          setSavedViewpointDetails,
          viewpointBuilderNavigationOperations.setSavedViewpointDetails
        ),
        reducer(
          resetViewpointBuilderNavigation,
          viewpointBuilderNavigationOperations.resetState
        ),
      ],
      { namespace }
    ),
    i18nLocale$,
  ]).pipe(
    map(([state, i18nLocale]) =>
      viewpointBuilderNavigationOperations.composeViewModel(state, i18nLocale)
    ),
    shareReplay({ bufferSize: 1, refCount: true })
  );
